<h1 mat-dialog-title>ASSEGNA CODICE PROFILO PROFESSIONALE<mat-icon class="close-icon" (click)="onClose()">close</mat-icon></h1>
<div mat-dialog-content>

  <div class="d-flex">
    <mat-form-field *ngIf="!checkOverrideProposta" style="margin-top:20px; margin-right: auto; margin-left: auto">
      <mat-label>Codice profilo professionale*</mat-label>
      <input matInput type="text" pattern="^\d+(\.\d{1,3})?$" [(ngModel)]="data.code">
    </mat-form-field>
  </div>




  <div *ngIf="checkOverrideProposta" class="mb-15">
    <div>
      <h1 class="title-heading black"><span class="green">Trovato profilo esistente con codice </span> {{ data.code }}</h1>
    </div>

      <div class="mt-15 half-width">
        <h2 class="title-heading black">Profilo da archiviare</h2>
        <mat-form-field class="full-width">
          <mat-label>ID</mat-label>
          <input matInput [value]="duplicatedRecord?.profilo?.idProfilo" readonly>
        </mat-form-field>       

        <mat-form-field class="full-width">
          <mat-label>Codice profilo</mat-label>
          <input matInput [value]="duplicatedRecord?.profilo?.codiceProfilo" readonly>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Nome profilo</mat-label>
          <input matInput [value]="duplicatedRecord?.profilo?.nomeProfilo" readonly>
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Descrizione</mat-label>
          <textarea
            rows="5"
            matInput
            placeholder="Descrizione"
            [value]="duplicatedRecord?.profilo?.descrizioneProfilo"
            name="descrizione"
            readonly
          ></textarea>
        </mat-form-field>
      </div>

      <div class="mt-15 half-width">
        <h2 class="title-heading black">Profilo nuovo</h2>
      <mat-form-field class="full-width">
        <mat-label>ID</mat-label>
        <input matInput [value]="newProfile?.idProfilo" >
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Codice profilo</mat-label>
        <input matInput [value]="newProfile?.codiceProfilo" >
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Nome profilo</mat-label>
        <input matInput [value]="newProfile?.nomeProfilo" >
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Descrizione</mat-label>
        <textarea
          rows="5"
          matInput
          placeholder="Descrizione"
          [value]="newProfile?.descrizioneProfilo"
          name="descrizione"
          
        ></textarea>
      </mat-form-field>

    </div>
</div>

</div>

<div mat-dialog-actions class="actions mt-15">
  <button *ngIf="checkOverrideProposta" mat-fab extended class="searchbox-buttons back-button" (click)="switchOverReplaceAndArchiveMode()">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onClose()">
    <mat-icon>close</mat-icon>
    Annulla
  </button>
  <!--    <button mat-fab extended class="searchbox-buttons save-button" [mat-dialog-close]="data">-->
  <button *ngIf="!checkOverrideProposta" mat-fab extended class="searchbox-buttons save-button" (click)="handleAssignment()">
    <mat-icon>compare_arrows</mat-icon>
    Assegna
  </button>

  <button *ngIf="checkOverrideProposta" color="primary" mat-fab extended class="searchbox-buttons" (click)="replaceAndArchive()">
    <mat-icon>swap_horiz</mat-icon>
    Sostituisci ed Archivia
  </button>

</div>
